
import { defineComponent, ref, computed, PropType, watch } from "vue";
import { usePlugin } from "@/plugins";
import {
  TrainingAttendance,
  GetTrainingAttendanceResponse,
  TrainingAttendanceUpdateDto,
  TrainingDocument,
  TrainingTypeEnum,
  DeleteTrainingAttendanceRequest,
  UpsertTrainingAttendanceResponse,
} from "@/types";
import Fuse from "fuse.js";
import { clone } from "ramda";
// import InputUser from "@/components/InputUser.vue";
import useUpload from "@/upload";
import AssessmentBadge from "@/components/AssessmentBadge.vue";
import { useConfirm } from "primevue/useconfirm";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
export default defineComponent({
  name: "TrainingAttendanceList",
  components: { AssessmentBadge },
  props: {
    items: Array as PropType<TrainingAttendance[]>,
    document: {} as PropType<TrainingDocument>,
    disabled: {
      type: Boolean,
    },
  },
  setup(props) {
    const {
      success,
      error,
      axios,
      setLoading,
      information,
      onRouterPush,
    } = usePlugin();
    const { showUpload } = useUpload();
    const trainingAttendances = ref<TrainingAttendance[]>([]);
    const trainingAttendance = ref<TrainingAttendance>(
      {} as TrainingAttendance
    );
    const selectedUser = ref("");
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const popupConfirmDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const isUploadPopup = ref(false);
    const confirm = useConfirm();
    const editUser = ref(false);
    const oldEmployeeId = ref("");
    const errors = ref<string[]>([]);
    const isShowInternalAssessment = computed(() => {
      return props.document?.trainingType === TrainingTypeEnum.Internal;
    });
    const isShowExternalAssessment = computed(() => {
      return props.document?.trainingType === TrainingTypeEnum.External;
    });

    const filteredTrainingAttendance = computed(() => {
      if (!searchString.value) return trainingAttendances.value;
      const fuse = new Fuse(trainingAttendances.value, {
        keys: ["employeeId", "User.fullName", "User.position"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const addedUsers = ref("");
    const validateInput = (value: any) => {
      if (typeof value !== "string") return false;
      if (value.split("\n").filter((x) => x.length > 5).length > 0)
        return false;
      return true;
    };
    const rules = {
      addedUsers: {
        required,
        validateInput: helpers.withMessage(
          "กรุณาระบุ Employee ID บรรทัดละ 1 Employee ID ความยาวบรรทัดละไม่เกิน 5 ตัวอักษร",
          validateInput
        ),
      },
    };
    const v$ = useVuelidate(
      rules,
      {
        addedUsers,
      },
      { $scope: false }
    );

    const onSaveTrainingAttendance = async () => {
      v$.value.$reset();
      v$.value.$touch();
      if ((await v$.value.$validate()) === false) return;

      submitted.value = true;
      setLoading(true);
      // if (oldEmployeeId.value !== selectedUser.value) {
      //   let trainingAttendanceUpdateDto = {
      //     trainingAttendancesUpdate: [
      //       {
      //         trainingDocumentId: props.document?.id,
      //         employeeId: selectedUser.value,
      //       } as TrainingAttendance,
      //     ],
      //   } as TrainingAttendanceUpdateDto;

      //   if (oldEmployeeId.value !== "") {
      //     trainingAttendanceUpdateDto.trainingAttendancesDelete = [
      //       {
      //         trainingDocumentId: props.document?.id,
      //         employeeId: oldEmployeeId.value,
      //       } as TrainingAttendance,
      //     ];
      //   }

      const trainingAttendanceUpdateDto: TrainingAttendanceUpdateDto = {
        trainingAttendancesDelete: null,
        trainingAttendancesUpdate: addedUsers.value
          .split("\n")
          .filter((x) => x)
          .map(
            (x) =>
              ({
                trainingDocumentId: props.document?.id ?? "",
                employeeId: x,
              } as TrainingAttendance)
          ),
      };

      try {
        const result = await axios.post<UpsertTrainingAttendanceResponse>(
          "api/v1/services/trainingAttendance/upsert",
          trainingAttendanceUpdateDto
        );

        if (result.data.errors && result.data.errors.length > 0) {
          errors.value = result.data.errors;
          return;
        }

        success("บันทึกข้อมูลสำเร็จแล้ว");
        showDialog.value = false;
        await loadTrainingAttendances();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
    };

    const onNewTrainingAttendance = async () => {
      trainingAttendance.value = {} as TrainingAttendance;
      selectedUser.value = "";
      showDialog.value = true;
      submitted.value = false;
      editUser.value = false;
      oldEmployeeId.value = "";
    };

    const onEditTrainingAttendance = async (source: TrainingAttendance) => {
      trainingAttendance.value = {} as TrainingAttendance;
      selectedUser.value = "";
      showDialog.value = true;
      submitted.value = false;
      editUser.value = true;
      oldEmployeeId.value = clone(source.employeeId ?? "N/A");
    };

    const onDeleteTrainingAttendance = async (source: TrainingAttendance) => {
      trainingAttendance.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const loadTrainingAttendances = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetTrainingAttendanceResponse>(
          `api/v1/services/trainingAttendance/${props.document?.id}`
        );
        trainingAttendances.value = result.data.trainingAttendances ?? [];
        // trainingAttendances.value = [] as TrainingAttendance[];
        // if (result.data.trainingAttendances) {
        //   for (let i = 0; i < result.data.trainingAttendances.length; i++) {
        //     const trainingAttendance = result.data.trainingAttendances[i];

        //     // const user = await searchUser(
        //     //   trainingAttendance?.employeeId ?? "N/A"
        //     // );
        //     // if (user && user.length > 0) {
        //     //   const trainingAttendanceDto = ref<TrainingAttendance>({
        //     //     trainingDocumentId: trainingAttendance.trainingDocumentId,
        //     //     employeeId: trainingAttendance.employeeId,
        //     //   } as TrainingAttendance);
        //     //   trainingAttendances.value.push(trainingAttendanceDto.value);
        //     // }
        //   }
        // }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const fileName = ref({} as FileList);

    const onUploadAttendance = async () => {
      showUpload(async (files: FileList | null) => {
        if (files && !files.length) {
          error("กรุณาระบุไฟล์ที่ต้องการ upload");
        }
        // handleUploadAttendance(files![0]);
        confirm.require({
          message: "ข้อมูลทั้งหมดจะถูกลบและ สร้างใหม่ตามข้อมูลใน Excel",
          header: "ยืนยัน upload ข้อมูล",
          icon: "pi pi-exclamation-triangle",
          accept: async () => {
            setLoading(true);
            const formData = new FormData();
            formData.append("file", files![0]);
            formData.append("trainingDocumentNo", props.document?.id ?? "");
            try {
              const result = await axios.post(
                "api/v1/services/attendance/upload",
                formData,
                {
                  timeout: 120000,
                }
              );
              success("upload ข้อมูลเรียบร้อยแล้ว");
              await loadTrainingAttendances();
              isUploadPopup.value = false;
            } catch (e) {
              error(e);
            } finally {
              setLoading(false);
            }
          },
          reject: () => {
            information("การ upload ถูกยกเลิกแล้ว");
            isUploadPopup.value = false;
          },
        });
      });
    };

    const handleUploadAttendance = async (file: any) => {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const result = await axios.post(
          "api/v1/services/attendance/upload",
          formData,
          {
            timeout: 120000,
          }
        );
        success("upload ข้อมูลเรียบร้อยแล้ว");
        await loadTrainingAttendances();
        isUploadPopup.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      popupConfirmDialog.value = false;
    };

    watch(
      () => props.items,
      () => (trainingAttendances.value = clone(props.items ?? []))
    );

    const isReadonly = (trainingAttendance: TrainingAttendance) => {
      if (
        trainingAttendance.assessments !== null &&
        (trainingAttendance.assessments?.length ?? 0) > 0
      ) {
        if (
          trainingAttendance.assessments.findIndex((x) => !!x.assessmentData) >=
          0
        ) {
          return true;
        }
      }
      return false;
    };

    const handleDeleteTrainingAttendance = async () => {
      setLoading(true);
      try {
        const result = await axios.delete(
          "api/v1/services/trainingAttendance/delete",
          {
            data: {
              trainingAttendances: [
                {
                  trainingDocumentId:
                    trainingAttendance.value.trainingDocumentId,
                  employeeId: trainingAttendance.value.employeeId,
                },
              ],
            } as DeleteTrainingAttendanceRequest,
          }
        );
        await loadTrainingAttendances();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      // }
    };
    return {
      onNewTrainingAttendance,
      onEditTrainingAttendance,
      onDeleteTrainingAttendance,
      searchString,
      filteredTrainingAttendance,
      trainingAttendance,
      submitted,
      onHideDialog,
      showDialog,
      onSaveTrainingAttendance,
      popupDeleteDialog,
      handleDeleteTrainingAttendance,
      trainingAttendances,
      onUploadAttendance,
      isUploadPopup,
      popupConfirmDialog,
      TrainingTypeEnum,
      isShowInternalAssessment,
      isShowExternalAssessment,
      selectedUser,
      isReadonly,
      addedUsers,
      v$,
      errors,
    };
  },
});
